import {
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    useColorModeValue
} from '@chakra-ui/react'
import { useSearchParams } from '@remix-run/react'

import theme from '../../../../../Config/theme'

import { FaAngleDown } from 'react-icons/fa'

const SortBy = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const buttonBgColor = useColorModeValue('gray.100', 'gray.800')

    let sortByValue = searchParams.get('sortBy') || 'recent'

    const handleClick = (sortBy) => {
        searchParams.set('sortBy', sortBy)
        setSearchParams(searchParams)
    }

    const requestLabel = () => {
        switch (sortByValue) {
            case 'recent':
                return 'recent'
            case 'amountLowHigh':
                return 'amount low-high'
            case 'amountHighLow':
                return 'amount high-low'
            default:
                return 'recent'     
        }
    }

    return (
        <Menu>
            <MenuButton
                as={Button}
                rightIcon={<FaAngleDown />}
                borderRadius={'full'}
                bgColor={buttonBgColor}
                fontSize={'lg'}
                _hover={{}}
                _active={{}}
                _focus={{}}
            >
                {requestLabel()}
            </MenuButton>
            <MenuList>
                <MenuItem color={sortByValue === 'recent' && theme.default.defaultColor} onClick={() => handleClick('recent')}>recent</MenuItem>
                <MenuItem color={sortByValue === 'amountLowHigh' && theme.default.defaultColor} onClick={() => handleClick('amountLowHigh')}>amount low-high</MenuItem>
                <MenuItem color={sortByValue === 'amountHighLow' && theme.default.defaultColor} onClick={() => handleClick('amountHighLow')}>amount high-low</MenuItem>
            </MenuList>
        </Menu>
    )
}

export default SortBy